module.exports = __webpack_public_path__ + "static/img/loginrnd2.76d9dfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/loginrnd2.png
// module id = 352
// module chunks = 0